import { FC } from 'react';
import { useQuery } from '@apollo/client';
import { SHINE_START_REFUSAL_REASONS } from '@shinetools/shine-start-library';

import useCompanyContext from 'common/hooks/useCompanyContext';
import { throwIfErrorPresent } from 'features/Onboarding/utils';
import logger from 'helpers/logger';

import PageProps from '../PageProps';
import Component from './component';
import { shineStartRefusalReasonQuery } from './graphql';
import {
  ShineStartRefusalReasonQueryData,
  ShineStartRefusalReasonQueryVariables,
} from './types';

const ShineStartBusinessInfoRefused: FC<PageProps> = () => {
  const { companyProfileId } = useCompanyContext();

  const { data, error, loading } = useQuery<
    ShineStartRefusalReasonQueryData,
    ShineStartRefusalReasonQueryVariables
  >(shineStartRefusalReasonQuery, {
    variables: { companyProfileId: companyProfileId ?? '' },
  });
  throwIfErrorPresent(error);
  const refusalReasonCode = data?.viewer.company.shineStart?.error;
  if (
    refusalReasonCode !== null &&
    refusalReasonCode !== undefined &&
    !(refusalReasonCode in SHINE_START_REFUSAL_REASONS)
  ) {
    logger.warn(
      `Unrecognized Shine Start refusal reason: ${refusalReasonCode}`,
    );
    return <Component loading={loading} refusalReasonCode={null} />;
  }
  return (
    <Component
      loading={loading}
      refusalReasonCode={
        refusalReasonCode as keyof typeof SHINE_START_REFUSAL_REASONS
      }
    />
  );
};

export default ShineStartBusinessInfoRefused;
